export const ItemTypes = {
  TASK: 'task'
};


// WEBPACK FOOTER //
// ./lib/util/dnd.js